module.exports = __webpack_public_path__ + "306c6e34a57caa71698759ea58383a38.pdf";